import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'src/app/_services/message.service.';
import { CustomMessageModel } from './custom-message-model';

@Component({
  selector: 'app-custom-message',
  templateUrl: './custom-message.component.html',
  styleUrls: ['./custom-message.component.scss']
})
export class CustomMessageComponent implements OnInit {

  @Input()
  model!: CustomMessageModel;

  constructor(private messageService: MessageService) { }

  ngOnInit(): void {
  }

  close(){
    this.messageService.hide();
  }
}
